import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import BigCalendar from "react-big-calendar";
import { NotificationManager } from "react-notifications";
import HandleError from "../../../services/HandleError";
import TasksService from "../../../services/TasksService";
import LogHoursService from "../../../services/LogHoursService";
import LogsService from "../../../services/LogsService";
import ProjectsService from "../../../services/ProjectsService";
import AreasService from "../../../services/AreasService";
import LogHoursModal from "../../modals/LogHoursModal";
import EditLoggedHoursModal from "../../modals/EditLoggedHoursModal";
import TaskLog from "../../partials/TaskLog";
import DeleteModal from "../../modals/DeleteModal";
import { hoursToMinutes, minutesToHourAndMinutes, dataToSelectOption, groupArrayByProperty } from "../../helpers/HelperFunctions";

moment.locale("es-es", { week: { dow: 1 } }); // Monday is the first day of the week.
BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class LogHoursForm extends Component {
	state = {
		isLoading: false,
		isLoggingHours: false,
		isEditingHours: false,
		isLoadingProjects: false,
		isLoadingAreas: false,
		showLogModal: false,
		showEditModal: false,
		selectedTask: null,
		selectedLog: null,
		selectedArea: null,
		selectedProject: null,
		selectedLogType: null,
		directTask: false,
		logToDelete: null,
		editId: null,
		minutes: { value: 0, label: "0" },
		hours: "",
		projectName: "",
		progress: null,
		status_id: null,
		logsDate: {},
		formData: {},
		errors: {},
		loggedHours: [],
		tasks: [],
		projects: [],
		areas: [],
	}

	componentDidMount = () => {
		const date = moment();
		this.getLogHoursData(date.month() + 1, date.year());
	}

	onChange = (e) => { this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } }); };

	onChangeHours = (e) => {
		if (e.target.value !== "") {
			this.setState({ ...this.state, hours: parseInt(e.target.value, 0, 10) });
		} else {
			this.setState({ ...this.state, hours: 0 });
		}
	}

	onCheckboxChange = (e) => {
		this.setState({ ...this.state, isLoadingProjects: true, directTask: e.target.checked, formData: { ...this.state.formData, [e.target.name]: e.target.checked } });
		if (e.target.checked === true) {
			const projectsService = new ProjectsService(this);
			projectsService.index(0, "direct_logging=true").then((res) => {
				this.setState({ ...this.state, projects: this.mapArrayToSelectOption(res.data.projects), isLoadingProjects: false });
			}).catch((err) => {
				HandleError(err, this);
				this.setState({ isLoadingProjects: false });
			});
		}
	}

	onSelectChange = (option, name, selected) => {
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.value || "" } });
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}

	onMinutesSelectChange = (option) => {
		if (option !== null) {
			this.setState({ ...this.state, minutes: option });
		} else {
			this.setState({ ...this.state, minutes: { value: 0, label: "0" }, });
		}
	}

	onProjectsSelectChange = (option, name, selected) => {
		const areaService = new AreasService(this);
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.value || "" }, isLoadingAreas: true });
			areaService.index(0, `project_id=${option.value}`).then((res) => {
				this.setState({
					isLoadingAreas: false,
					areas: this.mapArrayToSelectOption(res.data.areas)
				});
			}).catch((err) => {
				this.setState({ isLoadingAreas: false });
				HandleError(err, this);
			});
		} else {
			this.setState({ [selected]: null, formData: { ...this.state.formData, [name]: null } });
		}
	}
	/**
	 * Registers new log data for specific task, also time is calculated here before submition.
	 */
	onSubmit = () => {
		const hours = hoursToMinutes(this.state.hours);
		const minutes = this.state.minutes ? this.state.minutes.value : 0;
		this.setState({
			...this.state,
			isLoggingHours: true,
			errors: {},
			formData: { ...this.state.formData, time: (hours + minutes).toString() }
		}, () => {
			this.logHoursService.store(this.state.formData).then((res) => {
				this.setState({
					isLoggingHours: false,
					showLogModal: false,
					selectedTask: null,
					selectedArea: null,
					selectedProject: null,
					directTask: false,
					minutes: { value: 0, label: "0" },
					hours: 0,
					formData: {},
					errors: {},
					loggedHours: [...this.state.loggedHours, (res.data.log_data || null)]
				});
				this.fetchTasks(this.state.logsDate);
				this.setDefaultLogType();
				NotificationManager.success("Log created.", "Success!");
			}).catch((err) => {
				this.setState({ isLoggingHours: false });
				HandleError(err, this);
			});
		});
	}

	/**
	 * Updates selected log, changes the loggedhours array in state.
	 */
	onUpdateSubmit = (e) => {
		const updateLogService = new LogsService(this);
		const hours = hoursToMinutes(this.state.hours);
		const minutes = this.state.minutes ? this.state.minutes.value : 0;

		this.setState({
			...this.state,
			isEditingHours: true,
			formData: { ...this.state.formData, time: (hours + minutes).toString() }
		}, () => {
			updateLogService.update(this.state.editId, this.state.formData).then((res) => {
				this.setState({
					isEditingHours: false,
					showEditModal: false,
					selectedTask: null,
					minutes: { value: 0, label: "0" },
					editId: null,
					hours: 0,
					formData: {},
					errors: {},
					loggedHours: this.state.loggedHours.map((item) => (item.id === res.data.log_data.id ? { ...item, ...res.data.log_data } : item))
				});
				this.fetchTasks(this.state.logsDate);
				this.setDefaultLogType();
				NotificationManager.success("Log Updated.", "Success!");
			}).catch((err) => {
				this.setState({ isEditingHours: false });
				HandleError(err, this);
			});
		});
	}

	/**
	 * Fetches logs and populates the state with logged hours
	 */
	getLogHoursData = (month, year) => {
		if (month && year) {
			this.setState({ ...this.state, isLoading: true, logsDate: { month, year } }, () => {
				this.fetchTasks(this.state.logsDate);
			});
		} else {
			this.setState({ isLoading: true });
			this.fetchTasks(this.state.logsDate);
		}
	}

	getLogTypes = () => {
		const logTypes = [
			{ value: 1, label: "Normal hours" },
			{ value: 2, label: "Extra hours" },
			{ value: 3, label: "Replacement hours" },
			{ value: 4, label: "Other" }
		];
		return logTypes;
	}

	setDefaultLogType = () => {
		this.setState({
			...this.state,
			selectedLogType: { value: 1, label: "Normal hours" },
			formData: {
				log_type_id: 1
			}
		});
	}

	handleLogHoursModal = (e) => {
		this.setDefaultLogType();
		if (e && e.start) {
			const date = moment(e.start).format("YYYY-MM-DD");
			this.setState({ ...this.state, formData: { ...this.state.formData, logged_at: date } });
		}
		this.setState((prevState) => ({
			showLogModal: !prevState.showLogModal,
			directTask: false,
			selectedTask: null,
			minutes: { value: 0, label: "0" },
			hours: 0,
			errors: {}
		}));
	}

	handleEditLoggedHoursModal = (loggedItem) => {
		if (loggedItem && loggedItem.allDay === undefined) {
			const { hours, minutes } = minutesToHourAndMinutes(loggedItem.time || null);
			const progress = this.findTaskProgress(loggedItem.task_id);
			this.setState({
				showEditModal: true,
				editId: loggedItem.id || null,
				projectName: loggedItem.project_name || "",
				progress,
				status_id: loggedItem.status_id || "",
				selectedLog: { name: `${loggedItem.title}`, id: loggedItem.id }, // for delete
				selectedLogType: { label: loggedItem.log_type_name, value: loggedItem.log_type_id },
				selectedTask: ({ value: loggedItem.task_id, label: loggedItem.title }),
				directTask: !!parseInt(loggedItem.is_directly_logged, 0, 10), // convert to boolean
				hours,
				minutes: ({ value: minutes, label: minutes.toString() }),
				formData: {
					logged_at: loggedItem.logged_at,
					task_id: loggedItem.task_id,
					description: loggedItem.description,
					directTask: !!parseInt(loggedItem.is_directly_logged, 0, 10),
					log_type_id: loggedItem.log_type_id,
					name: loggedItem.title
				},
			});
			if (loggedItem.is_directly_logged) {
				this.setState({
					selectedProject: dataToSelectOption(loggedItem.project_id, "value", loggedItem.project_name, "label"),
					selectedArea: dataToSelectOption(loggedItem.area_id, "value", loggedItem.area_name, "label"),
					selectedTask: dataToSelectOption(loggedItem.task_id, "value", loggedItem.title, "label")
				});
			}
		} else {
			this.closeEditModal();
		}
	}

	handleNavigate = (props) => {
		const date = moment(props);
		this.setState({ ...this.state, isLoading: true, logsDate: { month: date.month() + 1, year: date.year() } }, () => {
			this.fetchTasks(this.state.logsDate);
		});
	}

	fetchTasks = (date) => {
		this.setState({ isLoading: true });
		this.tasksService.fetchTasksToLogHours(date).then((res) => {
			this.setState({
				isLoading: false,
				loggedHours: res.data.logged_hours,
				tasks: this.mapTasks(res.data.tasks),
				isForcedToLog: res.data.forced_to_log || null
			});
		}).catch((err) => {
			this.setState({ isLoading: false });
			HandleError(err, this);
		}).then(() => {
			const loggedHoursPerDay = this.calculateLogsPerDay(this.state.loggedHours);
			this.setState({ loggedHours: [...loggedHoursPerDay, ...this.state.loggedHours] });
		});
	}

	calculateLogsPerDay = (loggedHours) => {
		if (loggedHours && Array.isArray(loggedHours)) {
			const groupedByDate = groupArrayByProperty(loggedHours, "logged_at");
			const calculatedLoggedHours = this.reduceLoggedHours(groupedByDate);
			return calculatedLoggedHours;
		}
		return [];
	}

	// accepts an associative array
	reduceLoggedHours = (groupedLoggedHours) => {
		if (groupedLoggedHours instanceof Object) {
			return Object.keys(groupedLoggedHours).map((key, index) => {
				if (groupedLoggedHours[key] && Array.isArray(groupedLoggedHours[key])) {
					const calculatedItem = groupedLoggedHours[key].reduce((accumulator, currentItem) => ({
						...accumulator,
						id: currentItem.id + currentItem.start,
						title: accumulator.time === undefined ? currentItem.time : accumulator.time + currentItem.time,
						time: accumulator.time === undefined ? currentItem.time : accumulator.time + currentItem.time,
						start: currentItem.start,
						end: currentItem.end,
						logged_at: currentItem.logged_at,
						allDay: true,
					}), {});
					return calculatedItem;
				}
				return null;
			});
		}
		return [];
	}

	findTaskProgress = (taskId) => {
		const { tasks } = this.state;
		if (taskId && tasks && Array.isArray(tasks)) {
			const task = tasks.find((item) => (item.value && item.value === taskId));
			if (task) {
				return parseFloat(task.task_progress);
			}
			return 100; // task is directly logged and the progress is always 100%
		}
		return null;
	}

	mapArrayToSelectOption = (array) => {
		if (array && Array.isArray(array)) {
			return array.map((item) => ({ value: item.id, label: item.name }));
		}
		return [];
	}

	mapTasks = (tasks) => {
		if (tasks && Array.isArray(tasks)) {
			return tasks.map((item) => ({ label: `${item.label}. (${item.project_name} - ${item.task_progress}%)`, value: item.value, task_progress: item.task_progress || null }));
		}
		return null;
	}

	logToDelete = (log) => {
		const { selectedLog } = this.state;
		if (selectedLog !== null) {
			this.closeEditModal();
			this.setState({ logToDelete: selectedLog });
		}
	}

	deleteLog = () => {
		if (this.state.logToDelete) {
			const logsService = new LogsService(this);
			this.setState({ isDeleting: true });
			logsService.delete(this.state.logToDelete.id).then((res) => {
				this.setState({ isDeleting: false });
				NotificationManager.success("Log deleted.", "Success!");
			}).catch((err) => {
				this.setState({ isDeleting: false });
				HandleError(err, this);
			}).then(() => {
				this.getLogHoursData();
				this.closeConfirmationModal();
			});
		}
	}

	closeConfirmationModal = () => {
		this.setState({
			logToDelete: null,
			selectedLog: null,
			isDeleting: false,
		});
	}

	closeEditModal = () => {
		this.setDefaultLogType();
		this.setState({
			...this.state,
			showEditModal: false,
			selectedTask: null,
			selectedProject: null,
			selectedArea: null,
			directTask: false,
			editId: null,
			minutes: { value: 0, label: "0" },
			errors: {},
			hours: 0,
		});
	}

	tasksService = new TasksService(this);
	logHoursService = new LogHoursService(this)

	render() {
		const {
			isLoading, isLoggingHours, isEditingHours, isDeleting, isLoadingProjects, isLoadingAreas,
			loggedHours, projects, areas,
			showLogModal, showEditModal, selectedLogType, selectedProject, selectedArea, projectName, status_id, progress,
			formData, tasks, errors, selectedTask, minutes, hours, logToDelete, directTask
		} = this.state;
		const logTypes = this.getLogTypes();

		return (
			<React.Fragment>
				<Link to="/my-logs" className="btn btn-default btn-crud">My logs</Link>
				<div className={`loading-screen ${isLoading ? "is-loading" : ""}`}><span>Loading...</span></div>
				<BigCalendar
					popup
					selectable
					events={loggedHours}
					views={["month"]}
					defaultDate={new Date()}
					startAccessor="start"
					endAccessor="end"
					className="log-hours-calendar"
					onSelectSlot={this.handleLogHoursModal} // User clicked on empty calendar slot, open modal to log new hours
					onSelectEvent={this.handleEditLoggedHoursModal} // User clicked logged hours, open modal to edit
					onNavigate={this.handleNavigate}
					titleAccessor={(e) => TaskLog(e, loggedHours)}
					tooltipAccessor={() => null}
				/>

				<LogHoursModal
					isForcedToLog={this.state.isForcedToLog}
					isLoggingHours={isLoggingHours}
					isLoadingProjects={isLoadingProjects}
					isLoadingAreas={isLoadingAreas}
					showLogModal={showLogModal}
					selectedTask={selectedTask}
					selectedProject={selectedProject}
					selectedArea={selectedArea}
					selectedLogType={selectedLogType}
					directTask={directTask}
					minutes={minutes}
					hours={hours}
					tasks={tasks}
					projects={projects}
					areas={areas}
					logTypes={logTypes}
					errors={errors}
					formData={formData}
					onSubmit={this.onSubmit}
					onChange={this.onChange}
					onChangeHours={this.onChangeHours}
					onMinutesSelectChange={this.onMinutesSelectChange}
					onCheckboxChange={this.onCheckboxChange}
					onSelectChange={this.onSelectChange}
					onProjectsSelectChange={this.onProjectsSelectChange}
					handleLogHoursModal={this.handleLogHoursModal}
				/>

				<EditLoggedHoursModal
					isEditingHours={isEditingHours}
					showEditModal={showEditModal}
					showDeleteBtn
					selectedTask={selectedTask}
					selectedLogType={selectedLogType}
					selectedProject={selectedProject}
					selectedArea={selectedArea}
					projectName={projectName}
					progress={progress}
					status={status_id}
					directTask={directTask}
					minutes={minutes}
					hours={hours}
					errors={errors}
					formData={formData}
					logTypes={logTypes}
					closeEditModal={this.closeEditModal}
					logToDelete={this.logToDelete}
					onUpdateSubmit={this.onUpdateSubmit}
					onChange={this.onChange}
					onChangeHours={this.onChangeHours}
					onMinutesSelectChange={this.onMinutesSelectChange}
					onSelectChange={this.onSelectChange}
				/>

				<DeleteModal
					itemToDelete={logToDelete}
					deleteItem={this.deleteLog}
					isDeleting={isDeleting}
					closeModal={this.closeConfirmationModal}
				/>
			</React.Fragment>
		);
	}
}

export default LogHoursForm;



// WEBPACK FOOTER //
// ./src/components/forms/logs/LogHoursForm.js